"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props, import/no-cycle */
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var client_1 = require("@apollo/client");
var PageContainer_1 = __importDefault(require("../../Elements/PageContainer"));
var ContentContainer_1 = __importDefault(require("../../Elements/ContentContainer"));
var BreadcrumbBar_1 = __importDefault(require("../../Elements/BreadcrumbBar"));
var Map_1 = __importDefault(require("../../../Map"));
var style_1 = require("./style");
var ContainersTable_1 = __importDefault(require("./Elements/ContainersTable"));
var InquiriesTable_1 = __importDefault(require("./Elements/InquiriesTable"));
var Button_1 = __importDefault(require("../../../Form/Elements/Button"));
var Settings_1 = __importDefault(require("../../../Form/Forms/Route/Create/Settings"));
var TabPane = antd_1.Tabs.TabPane;
var Step = antd_1.Steps.Step;
var RouteCreateView = function (_a) {
    var _b, _c, _d, _e;
    var breadcrumbBar = _a.breadcrumbBar, containersQuery = _a.containersQuery, inquiriesQuery = _a.inquiriesQuery, settingsMutation = _a.settingsMutation, preRouteMutation = _a.preRouteMutation, activeProjects = _a.activeProjects, projectSelect = _a.projectSelect, depotStartSelect = _a.depotStartSelect, depotEndSelect = _a.depotEndSelect, wasteStationSelect = _a.wasteStationSelect, wasteFractionSelect = _a.wasteFractionSelect, vehicleSelect = _a.vehicleSelect, driverSelect = _a.driverSelect, containerTypeSelect = _a.containerTypeSelect, containerDrawerQuery = _a.containerDrawerQuery, containerDrawerQueryVariablesFormatter = _a.containerDrawerQueryVariablesFormatter, containerDrawerQueryVariables = _a.containerDrawerQueryVariables, inquiryDrawerQuery = _a.inquiryDrawerQuery, inquiryDrawerQueryVariablesFormatter = _a.inquiryDrawerQueryVariablesFormatter, inquiryDrawerQueryVariables = _a.inquiryDrawerQueryVariables, mapBoxProps = _a.mapBoxProps;
    var _f = react_1.useState(false), settingsCompleted = _f[0], setSettingsCompleted = _f[1];
    var _g = react_1.useState({}), settingsValues = _g[0], setSettingsValues = _g[1];
    var _h = react_1.useState(false), showOptimizeModal = _h[0], setShowOptimizeModal = _h[1];
    var _j = react_1.useState(false), loading = _j[0], setLoading = _j[1];
    var _k = react_1.useState([]), stops = _k[0], setStops = _k[1];
    var _l = client_1.useQuery(containersQuery, {
        variables: {
            activeProjects: activeProjects,
        },
    }), containersQueryLoading = _l.loading, containersQueryData = _l.data;
    var _m = client_1.useQuery(inquiriesQuery, {
        variables: {
            activeProjects: activeProjects,
        },
    }), inquiriesQueryLoading = _m.loading, inquiriesQueryData = _m.data;
    var _o = client_1.useMutation(preRouteMutation), preRoute = _o[0], _p = _o[1], preRouteData = _p.data, preRouteLoading = _p.loading;
    var routes = ((_e = (_d = (_c = (_b = preRouteData === null || preRouteData === void 0 ? void 0 : preRouteData.preRoute) === null || _b === void 0 ? void 0 : _b.route) === null || _c === void 0 ? void 0 : _c.geoJson) === null || _d === void 0 ? void 0 : _d.features) === null || _e === void 0 ? void 0 : _e.map(function (route, index) {
        var _a, _b;
        return {
            id: index,
            locations: ((_b = (_a = route.geometry) === null || _a === void 0 ? void 0 : _a.coordinates) === null || _b === void 0 ? void 0 : _b.map(function (arr) {
                return {
                    longitude: arr[1],
                    latitude: arr[0],
                };
            })) || [],
        };
    })) || [];
    var containers = (stops === null || stops === void 0 ? void 0 : stops.filter(function (stop) { return stop.type === "container"; }).map(function (stop) { return ({
        id: stop.id,
        location: stop.location,
    }); })) || [];
    var mapLoading = containersQueryLoading || inquiriesQueryLoading || preRouteLoading;
    var handleStopDelete = react_1.useCallback(function (id) {
        setStops(function (old) { return old.filter(function (o) { return o.id !== id; }); });
    }, []);
    var actionPreRoute = react_1.useCallback(function () {
        preRoute({
            variables: {
                startDepotId: settingsValues.startDepot.value,
                endDepotId: settingsValues.endDepot.value,
                pickups: stops.map(function (stop) { return ({
                    id: stop.id,
                    type: stop.type,
                    stopNumber: stop.stopNumber,
                }); }),
            },
        });
    }, [preRoute, settingsValues, stops]);
    react_1.useEffect(function () {
        if (stops.length > 0 && settingsCompleted) {
            actionPreRoute();
        }
    }, [actionPreRoute, settingsCompleted, stops]);
    var handleContainerAdd = react_1.useCallback(function (selectedRows) {
        console.log("handleContainerAdd", selectedRows);
        setStops(function (prev) { return __spreadArray(__spreadArray([], prev), selectedRows.map(function (selectedRow, index) { return ({
            id: selectedRow.node.id,
            stopNumber: prev.length + index,
            type: "container",
            location: {
                latitude: selectedRow.node.location.latitude,
                longitude: selectedRow.node.location.longitude,
            },
        }); })); });
    }, []);
    var handleInquiryAdd = react_1.useCallback(function (selectedRows) {
        console.log("handleInquiryAdd", selectedRows);
        setStops(function (prev) { return __spreadArray(__spreadArray([], prev), selectedRows.map(function (selectedRow, index) { return ({
            id: selectedRow.node.id,
            stopNumber: prev.length + index,
            type: "inquiry",
            location: {
                latitude: 0,
                longitude: 0,
            },
        }); })); });
    }, []);
    return (react_1.default.createElement(PageContainer_1.default, null,
        breadcrumbBar && react_1.default.createElement(BreadcrumbBar_1.default, __assign({}, breadcrumbBar)),
        react_1.default.createElement(style_1.RouteCreateViewContainer, null,
            react_1.default.createElement(ContentContainer_1.default, null, !settingsCompleted ? (react_1.default.createElement(antd_1.Card, { title: "Setup" },
                react_1.default.createElement(antd_1.Steps, { size: "small", current: 0, style: { paddingBottom: "1rem" } },
                    react_1.default.createElement(Step, { title: "Setup" }),
                    react_1.default.createElement(Step, { title: "Add stops" }),
                    react_1.default.createElement(Step, { title: "Optimize" })),
                react_1.default.createElement(Settings_1.default, { mutation: settingsMutation, mutationVariablesFormatter: function (values) { return values; }, projectSelect: projectSelect, wasteFractionSelect: wasteFractionSelect, containerTypeSelect: containerTypeSelect, vehicleSelect: vehicleSelect, driverSelect: driverSelect, depotStartSelect: depotStartSelect, depotEndSelect: depotEndSelect, wasteStationSelect: wasteStationSelect, onSuccess: function (values) {
                        setSettingsCompleted(true);
                        setSettingsValues(values);
                    } }))) : (react_1.default.createElement(antd_1.Row, null,
                react_1.default.createElement(antd_1.Col, { span: 10 },
                    react_1.default.createElement("div", { className: "card-container" },
                        react_1.default.createElement(antd_1.Tabs, { type: "card", size: "small" },
                            react_1.default.createElement(TabPane, { tab: "Stops", key: "1" },
                                react_1.default.createElement("div", { style: { padding: "1rem" } }, stops.length <= 0 && (react_1.default.createElement(antd_1.Alert, { message: "You haven't added any stops - you can manually add containers or inquiries from the tabs above.", type: "warning", closable: true }))),
                                react_1.default.createElement(antd_1.List, { itemLayout: "horizontal", dataSource: stops, renderItem: function (stop) { return (react_1.default.createElement(antd_1.List.Item, { style: { padding: "1rem" }, actions: [
                                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                                            react_1.default.createElement(Button_1.default, { size: "small", danger: true, onClick: function () { return handleStopDelete(stop.id); }, title: "Remove from route", disabled: loading }),
                                        ] },
                                        react_1.default.createElement(antd_1.List.Item.Meta, { avatar: react_1.default.createElement(antd_1.Avatar, { style: {
                                                    color: "#ffffff",
                                                    backgroundColor: "#C4C4C4",
                                                } }, stop.stopNumber), title: "Stop " + stop.stopNumber, description: stop.type === "container"
                                                ? "Container #" + stop.id
                                                : "Inquiry #" + stop.id }))); } })),
                            react_1.default.createElement(TabPane, { tab: "Containers", key: "2" },
                                react_1.default.createElement(ContainersTable_1.default, { query: containersQuery, activeProjects: activeProjects, add: handleContainerAdd, containerDrawerQuery: containerDrawerQuery, containerDrawerQueryVariablesFormatter: containerDrawerQueryVariablesFormatter, containerDrawerQueryVariables: containerDrawerQueryVariables })),
                            react_1.default.createElement(TabPane, { tab: "Inquiries", key: "3" },
                                react_1.default.createElement(InquiriesTable_1.default, { query: inquiriesQuery, activeProjects: activeProjects, add: handleInquiryAdd, inquiryDrawerQuery: inquiryDrawerQuery, inquiryDrawerQueryVariablesFormatter: inquiryDrawerQueryVariablesFormatter, inquiryDrawerQueryVariables: inquiryDrawerQueryVariables }))))),
                react_1.default.createElement(antd_1.Col, { span: 14, style: { paddingLeft: "1rem" } }, mapLoading ? (react_1.default.createElement("div", null, "loading...")) : (react_1.default.createElement(Map_1.default, { mapBoxProps: mapBoxProps, containers: containers, inquiries: [], routes: routes, vehicles: [], depots: [] })))))))));
};
exports.default = RouteCreateView;
